import { useSelector } from 'react-redux'

import { selectShowNps } from 'redux/selectors/Surveys'

/**
 * Hook for checking if nps should be displayed.
 */
export const useShowNps = () => {
  return useSelector(selectShowNps)
}
